// NEW_FILE_JUSTIFIED: Reusable info card component for Plan Summary redesign - used by both Plan Overview and Claims & Billing cards
import { cn } from '@/lib/utils';
import { EditableCell } from '@/components/insurance/EditableCell';
import type { IPlanInfoCardProps } from '@/@types/claims';

const VALUE_COLOR_MAP: Record<string, string> = {
  danger: 'text-red-500 font-semibold',
  warning: 'text-orange-500 font-semibold',
};

export function PlanInfoCard({ icon, title, rows, onSave }: IPlanInfoCardProps) {
  return (
    <div className="rounded-xl border bg-card overflow-hidden">
      <div className="flex items-center gap-2.5 px-5 py-4 border-b">
        {icon}
        <span className="text-sm font-semibold text-foreground">{title}</span>
      </div>
      <div>
        {rows.map((row, i) => (
          <div
            key={row.saveKey}
            className={cn(
              'flex items-start px-5 py-3',
              i < rows.length - 1 && 'border-b border-border/40',
              i % 2 !== 0 && 'bg-muted/30'
            )}
          >
            <span className="w-[180px] shrink-0 text-[13px] text-muted-foreground pt-0.5">
              {row.label}
            </span>
            <div className="flex-1 flex items-center gap-2 min-w-0">
              <EditableCell
                value={row.value}
                onSave={next => onSave(row.saveKey, next, row.source)}
                className={cn(
                  'text-[13px]',
                  row.color && row.color !== 'default'
                    ? VALUE_COLOR_MAP[row.color]
                    : 'font-medium text-foreground'
                )}
              />
              {row.badge ? (
                <span className="inline-flex items-center rounded px-2 py-0.5 text-[11px] font-semibold text-green-400 light:text-green-600 bg-green-950/30 light:bg-green-50 border border-green-800 light:border-green-200">
                  {row.badge}
                </span>
              ) : null}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
